<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <card-item>
          <div class="d-flex justify-content-end">
            <button class="btn btn-danger btn-sm" @click="volver">
              Volver
            </button>
          </div>
        </card-item>

        <div class="row h-100">
          <div class="col h-100">
            <card-item
              body-classes="table-full-width table-responsive"
              class="striped-tabled-with-hover"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">{{ nombreCliente }}</h4>

                    <p class="card-category">Listado de Contratos</p>
                  </div>

                  <div class="button-group">
                    <button
                      class="btn btn-warning"
                      @click="historialDeMantenimientos"
                    >
                      Historial de mantenimientos
                    </button>
                    <button class="btn btn-primary" @click="crearContrato">
                      Añadir contrato
                    </button>
                  </div>
                </div>
              </template>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="label" for="quickFilter">
                        Filtro rapido
                      </label>

                      <input
                        id="quickFilter"
                        v-model="quickFilter"
                        class="form-control"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      :columnDefs="columnDefs"
                      :gridOptions="gridOptions"
                      :defaultColDef="defaultColDef"
                      :rowData="rowData"
                      @grid-ready="onGridReady"
                      :getRowStyle="getRowStyle"
                      :statusBar="statusBar"
                      :getContextMenuItems="getContextMenuItems"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContratosTabla from "@/pages/Clientes/Contratos/Tabla/ContratosTabla";
import { AgGridVue } from "ag-grid-vue";
import { get } from "lodash-es";

export default {
  name: "ContratosList",
  components: { AgGridVue },
  mixins: [ContratosTabla],
  mounted() {
    this.clienteId = this.$route.params.id_cliente;
    this.$store
      .dispatch("Contratos/getNombreWeb", this.clienteId)
      .then((resp) => {
        if (get(resp, "ok", true) == false) {
          this.$msgBoxOk(resp.message);
        }
      });
  },
  computed: {
    nombreCliente() {
      return get(this.$store.state.Contratos, "nombreWeb", "Contratos");
    },
  },
  data: () => ({
    clienteId: 0,
    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      minWidth: 100,
    },
  }),
  methods: {
    volver() {
      this.$router.push(`/admin/clientes/`);
    },
    crearContrato() {
      this.$router.push(
        `/admin/clientes/${this.$route.params.id_cliente}/contratos/nuevo`,
      );
    },
    historialDeMantenimientos() {
      this.$router.push(
        `/admin/clientes/${this.$route.params.id_cliente}/contratos/historial-de-mantenimientos`,
      );
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getContratos();
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
};
</script>

<style scoped></style>
